import { View, TouchableOpacity } from "react-native";
import { Text } from "react-native-paper";

interface Props extends React.ComponentProps<typeof TouchableOpacity> {
  textClassName?: string;
}

export default function LinkButton({ children, textClassName = "", ...props }: Props) {
  return (
    <TouchableOpacity {...props} activeOpacity={0.7} hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}>
      <View className="border-b border-primary">
        <Text
          className={`
          text-primary 
          text-regular-normal 
          font-400
          ${textClassName} 
        `}
          testID="linkbutton-text"
        >
          {children}
        </Text>
      </View>
    </TouchableOpacity>
  );
}
